/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Tag, Timeline } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../dpia/components/iconEmpty';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';

export default function History({ service, callHistory, setCallHistory }) {
    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    console.log(id)
    const getHistory = async () => {
        setLoading(true);
        try {
            setTimeout(async () => {
                const { data } = await service(id);
                if (data?.resultData) {
                    // if (params.p === 1) {
                    //     setHistories(data.resultData?.result);
                    //     setPage(2);
                    // } else {
                    //     const history = histories.concat(
                    //         data.resultData?.result
                    //     );
                    //     setHistories(history);
                    //     setPage(page + 1);
                    // }
                    // const history = histories.concat(
                    //     data.resultData?.result
                    // );
                    setHistories(data.resultData);
                    setPage(page + 1);
                    // setTotal(data?.resultData?.total);
                    setLoading(false);
                }
            }, 300);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (callHistory) {
            setHistories([]);
            getHistory();
            setCallHistory(false);
        }
    }, [callHistory]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            getHistory();
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories.length > 0 ? (
                        histories.map((item, i) => (
                            <Timeline.Item
                                key={item?.organizePermissionHistoryId}
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                            >
                                <button
                                    className={classNames(
                                        'bg-[#EDEEF9] p-2 rounded-lg space-y-2 text-left w-full',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                // onClick={() =>
                                //     navigate(
                                //         `${ROUTER.DS_INVENTORY.DATAFLOW}/${item.businessProcessHistoryId}/historyDetail`
                                //     )
                                // }
                                >
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.LogDate')} :
                                        </div>
                                        <div className="col-span-3">
                                            {item.logDate}
                                        </div>
                                    </div>{' '}
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.updateBy')} :
                                        </div>
                                        <div className="col-span-3">
                                            {item.logBy || '-'}
                                        </div>
                                    </div>{' '}
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.Action')} :
                                        </div>
                                        <div className="col-span-3">
                                            <Tag
                                                className="rounded-xl -my-1 text-center"
                                                style={{ color: 'white', borderColor: '#7B67FB', backgroundColor: '#7B67FB' }}
                                            >
                                                {item.action === "Edit" ? t('dataFlow.Edit action') : t('dataFlow.Create action')}
                                            </Tag>
                                        </div>
                                    </div>
                                </button>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
